export const LOGIN_REQUESTED: string = 'LOGIN_REQUESTED';
export const LOGOUT_REQUESTED: string = 'LOGOUT_REQUESTED';
export const RESET_STORE: string = 'RESET_STORE';
export const RESET_STORE_OPENED_CLAIMS: string = 'RESET_STORE_OPENED_CLAIMS';
